// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_byType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ChapterAreaGroup",
    "UserAreaGroup"
  ]);
}

let fragmentConverter = {"__root":{"byType":{"u":"fragment_byType"}}};

let fragmentConverterMap = {
  fragment_byType: unwrap_fragment_byType
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function areaTypeV5_decode($$enum) {
  if ($$enum === "BLOCK_GROUP" || $$enum === "ZIP_CODE" || $$enum === "CENSUS_PLACE" || $$enum === "TOWNSHIP" || $$enum === "CITY" || $$enum === "STATE" || $$enum === "COUNTY" || $$enum === "SCHOOL_DISTRICT" || $$enum === "NEIGHBORHOOD" || $$enum === "SCHOOL") {
    return $$enum;
  }
}

let areaTypeV5_fromString = areaTypeV5_decode;

function matchableEntityType_decode($$enum) {
  if ($$enum === "BUYER_NEED" || $$enum === "RENTAL_PROPERTY" || $$enum === "FOR_SALE_PROPERTY" || $$enum === "RENTAL_NEED" || $$enum === "NEW_DEVELOPMENT") {
    return $$enum;
  }
}

let matchableEntityType_fromString = matchableEntityType_decode;

let Utils = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: matchableEntityType_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsNewDevelopments_areaGroup",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Area",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": "type_",
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    },
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usedFor",
                "storageKey": null
              }
            ],
            "type": "UserAreaGroup",
            "abstractKey": null
          }
        ],
        "type": null,
        "abstractKey": null
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "byType"
    }
  ],
  "type": "AreaGroupV5",
  "abstractKey": "__isAreaGroupV5"
};
})());

let wrap_fragment_byType = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_byType = unwrap_fragment_byType;
exports.wrap_fragment_byType = wrap_fragment_byType;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
